/* eslint-disable */
import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import Login from '@/views/modules/login/index.vue'
import msalInstance from '@/views/modules/msal'
import { auth } from '@/views/modules/globalfunction'
// import { auths} from './views/modules/globalfunction'


var retrievedUserData = localStorage.getItem( "users" );
let userData = JSON.parse( retrievedUserData );

function guardMyroute ( to, from, next )
{
  var isAuthenticated = false;
  //this is just an example. You will have to find a better or
  // centralised way to handle you localstorage data handling
  if ( localStorage.getItem( 'token' ) )
    isAuthenticated = true;
  else
    isAuthenticated = false;
  if ( isAuthenticated )
  {
    next(); // allow to enter route
  }
  else
  {
    next( '/login' ); // go to '/login';
  }
}
function afterAuth ( to, from, next )
{
  let ok = localStorage.getItem('Ok');
  let ssoToken = localStorage.getItem('SSOToken');
  // auth(ssoToken);
  if (ok) {
    auth(ssoToken);
    next();

  }
  else {
    next( '/login' );
  }
  next();
}
function roleGuardSystemLibrary ( to, from, next )
{
  var isAuthenticated = false;
  let user = JSON.parse( localStorage.getItem( 'users' ) );
  //this is just an example. You will have to find a better or
  // centralised way to handle you localstorage data handling

  if ( !localStorage.getItem( 'token' ) )
  {
    next( '/login' );
  } else
  {
    if ( user )
    {
      if ( user[ 'RoleType' ] == 'System Admin' )
      {
        isAuthenticated = true;
      } else
      {
        isAuthenticated = false;
      }
    } else
    {
      isAuthenticated = false;
    }

  }
  if ( isAuthenticated == true )
  {
    next(); // allow to enter route
  }
  else
  {
    next( '/401' ); // go to '/login';
  }
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import( '@/views/modules/login/index.vue' ),
  },
  {
    path: '/registrationcode',
    name: 'Login Registration Code',
    component: () => import( '@/views/modules/login/loginRegistrationCode.vue' ),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import( '@/views/modules/login/register-external.vue' ),
  },
  {
    path: '/verification',
    name: 'Verfication Code',
    component: () => import( '@/views/modules/login/verificationCode.vue' ),
  },
  {
    path: '/forgotPasswordOTP',
    name: 'Forgot Password OTP',
    component: () => import( '@/views/modules/login/forgotPasswordOTP.vue' ),
  },
  {
    path: '/resetPassword',
    name: 'Reset Password',
    component: () => import( '@/views/modules/login/resetPassword.vue' ),
  },
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/login',
    meta: { requiresAuth: true },
    beforeEnter: afterAuth,
    children: [

      {
        path: '/401',
        name: '401',
        beforeEnter: guardMyroute,
        component: () => import( '@/views/pages/Page401' ),
      },

   {
        path: '/list-of-rfps',
        name: 'List of RFPs',
        // beforeEnter: roleGuardSystemLibrary,

        component: {
          render ()
          {
            return h( resolveComponent( 'router-view' ) )
          },
        },
        redirect: '/list-of-rfps/request-list',

        children: [
          //---------------------------------------------------------------------

          {
            path: '/list-of-rfps/request-list',
            name: 'REQUEST FOR PAYMENT',
            component: () => import( '@/views/modules/list-of-rfps/approver-view/index.vue' ),
          },
          {
            path: '/list-of-rfps/approver-list',
            name: 'APPROVE PAYMENT',
            component: () => import( '@/views/modules/list-of-rfps/approver-view/index.approver.vue' ),
          },
          {
            path: '/list-of-rfps/requestor',
            name: 'NEW REQUEST',
            component: () => import( '@/views/modules/list-of-rfps/approver-view/add.vue' ),
          },
          {
            path: '/list-of-rfps/Reviewer-view',
            name: 'APPROVER VIEW',
            component: () => import( '@/views/modules/list-of-rfps/approver-view/reviewer_view.vue' ),
          },
          {
            path: '/list-of-rfps/confirmation',
            name: 'Confirmation',
            component: () => import( '@/views/modules/list-of-rfps/approver-view/confirmation.vue' ),
          },
          //---------------------------------------------------------------------

        ],
      },

      {
        path: '/theme',
        name: 'Theme',
        redirect: '/theme/typography',
      },
      {
        path: '/theme/colors',
        name: 'Hello World',
        component: () => import( '@/views/theme/Colors.vue' ),
      },
      {
        path: '/theme/colors',
        name: 'Colors',
        component: () => import( '@/views/theme/Colors.vue' ),
      },
      {
        path: '/theme/typography',
        name: 'Typography',
        component: () => import( '@/views/theme/Typography.vue' ),
      },
      {
        path: '/base',
        name: 'Base',
        component: {
          render ()
          {
            return h( resolveComponent( 'router-view' ) )
          },
        },
        redirect: '/base/breadcrumbs',
        children: [
          {
            path: '/base/accordion',
            name: 'Accordion',
            component: () => import( '@/views/base/Accordion.vue' ),
          },
          {
            path: '/base/breadcrumbs',
            name: 'Breadcrumbs',
            component: () => import( '@/views/base/Breadcrumbs.vue' ),
          },
          {
            path: '/base/cards',
            name: 'Cards',
            component: () => import( '@/views/base/Cards.vue' ),
          },
          {
            path: '/base/carousels',
            name: 'Carousels',
            component: () => import( '@/views/base/Carousels.vue' ),
          },
          {
            path: '/base/collapses',
            name: 'Collapses',
            component: () => import( '@/views/base/Collapses.vue' ),
          },
          {
            path: '/base/list-groups',
            name: 'List Groups',
            component: () => import( '@/views/base/ListGroups.vue' ),
          },
          {
            path: '/base/navs',
            name: 'Navs',
            component: () => import( '@/views/base/Navs.vue' ),
          },
          {
            path: '/base/paginations',
            name: 'Paginations',
            component: () => import( '@/views/base/Paginations.vue' ),
          },
          {
            path: '/base/placeholders',
            name: 'Placeholders',
            component: () => import( '@/views/base/Placeholders.vue' ),
          },
          {
            path: '/base/popovers',
            name: 'Popovers',
            component: () => import( '@/views/base/Popovers.vue' ),
          },
          {
            path: '/base/progress',
            name: 'Progress',
            component: () => import( '@/views/base/Progress.vue' ),
          },
          {
            path: '/base/spinners',
            name: 'Spinners',
            component: () => import( '@/views/base/Spinners.vue' ),
          },
          {
            path: '/base/tables',
            name: 'Tables',
            component: () => import( '@/views/base/Tables.vue' ),
          },
          {
            path: '/base/tooltips',
            name: 'Tooltips',
            component: () => import( '@/views/base/Tooltips.vue' ),
          },
        ],
      },
      {
        path: '/buttons',
        name: 'Buttons',
        component: {
          render ()
          {
            return h( resolveComponent( 'router-view' ) )
          },
        },
        redirect: '/buttons/standard-buttons',
        children: [
          {
            path: '/buttons/standard-buttons',
            name: 'Buttons',
            component: () => import( '@/views/buttons/Buttons.vue' ),
          },
          {
            path: '/buttons/dropdowns',
            name: 'Dropdowns',
            component: () => import( '@/views/buttons/Dropdowns.vue' ),
          },
          {
            path: '/buttons/button-groups',
            name: 'Button Groups',
            component: () => import( '@/views/buttons/ButtonGroups.vue' ),
          },
        ],
      },
      {
        path: '/forms',
        name: 'Forms',
        component: {
          render ()
          {
            return h( resolveComponent( 'router-view' ) )
          },
        },
        redirect: '/forms/form-control',
        children: [
          {
            path: '/forms/form-control',
            name: 'Form Control',
            component: () => import( '@/views/forms/FormControl.vue' ),
          },
          {
            path: '/forms/select',
            name: 'Select',
            component: () => import( '@/views/forms/Select.vue' ),
          },
          {
            path: '/forms/checks-radios',
            name: 'Checks & Radios',
            component: () => import( '@/views/forms/ChecksRadios.vue' ),
          },
          {
            path: '/forms/range',
            name: 'Range',
            component: () => import( '@/views/forms/Range.vue' ),
          },
          {
            path: '/forms/input-group',
            name: 'Input Group',
            component: () => import( '@/views/forms/InputGroup.vue' ),
          },
          {
            path: '/forms/floating-labels',
            name: 'Floating Labels',
            component: () => import( '@/views/forms/FloatingLabels.vue' ),
          },
          {
            path: '/forms/layout',
            name: 'Layout',
            component: () => import( '@/views/forms/Layout.vue' ),
          },
          {
            path: '/forms/validation',
            name: 'Validation',
            component: () => import( '@/views/forms/Validation.vue' ),
          },
        ],
      },
      {
        path: '/charts',
        name: 'Charts',
        component: () => import( '@/views/charts/Charts.vue' ),
      },
      {
        path: '/icons',
        name: 'Icons',
        component: {
          render ()
          {
            return h( resolveComponent( 'router-view' ) )
          },
        },
        redirect: '/icons/coreui-icons',
        children: [
          {
            path: '/icons/coreui-icons',
            name: 'CoreUI Icons',
            component: () => import( '@/views/icons/CoreUIIcons.vue' ),
          },
          {
            path: '/icons/brands',
            name: 'Brands',
            component: () => import( '@/views/icons/Brands.vue' ),
          },
          {
            path: '/icons/flags',
            name: 'Flags',
            component: () => import( '@/views/icons/Flags.vue' ),
          },
        ],
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: {
          render ()
          {
            return h( resolveComponent( 'router-view' ) )
          },
        },
        redirect: '/notifications/alerts',
        children: [
          {
            path: '/notifications/alerts',
            name: 'Alerts',
            component: () => import( '@/views/notifications/Alerts.vue' ),
          },
          {
            path: '/notifications/badges',
            name: 'Badges',
            component: () => import( '@/views/notifications/Badges.vue' ),
          },
          {
            path: '/notifications/modals',
            name: 'Modals',
            component: () => import( '@/views/notifications/Modals.vue' ),
          },
        ],
      },
      {
        path: '/widgets',
        name: 'Widgets',
        component: () => import( '@/views/widgets/Widgets.vue' ),
      },
    ],
  },

]

const router = createRouter( {
  history: createWebHistory(),
  routes,
  // scrollBehavior() {
  //   // always scroll to top
  //   return { top: 0 }
  // },
} )


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!msalInstance.getAllAccounts().length) {
      msalInstance.loginRedirect();
    } else {
    next();
    }
  } else {
    next();
  }
});


export default router
